var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "avue-crud",
        {
          ref: "crud",
          attrs: {
            "table-loading": _vm.list.loading,
            option: _vm.option,
            data: _vm.list.data,
          },
          on: { "refresh-change": _vm.refreshChange },
          scopedSlots: _vm._u([
            {
              key: "channelId",
              fn: function ({ row }) {
                return [
                  _c("span", [
                    _vm._v(_vm._s(`[${row.channelId}] ${row.channelName}`)),
                  ]),
                ]
              },
            },
            {
              key: "menu",
              fn: function ({ row }) {
                return [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "SECURITY_CHANNEL_CONFIG_EDIT",
                          expression: "'SECURITY_CHANNEL_CONFIG_EDIT'",
                        },
                      ],
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(row)
                        },
                      },
                    },
                    [_vm._v("\n        编辑\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "SECURITY_CHANNEL_CONFIG_DEL",
                          expression: "'SECURITY_CHANNEL_CONFIG_DEL'",
                        },
                      ],
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.del(row.id)
                        },
                      },
                    },
                    [_vm._v("\n        删除\n      ")]
                  ),
                ]
              },
            },
          ]),
        },
        [_c("template", { slot: "mySearch" }, [_c("Search")], 1)],
        2
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          "current-page": _vm.searchParams.current,
          "page-size": _vm.searchParams.size,
          total: _vm.searchParams.total,
          "page-sizes": [10, 20, 30, 40, 50],
          disabled: _vm.list.disabled,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("Add", { ref: "add" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }